// extracted by mini-css-extract-plugin
export default {"table":"zvKZCnehVpAbo5SoOfHF","group":"tSn_sG7bduE_G0aYNQJx"};